<template lang="pug">
base-layout
  template(v-slot:before-footer)
    k-tour-get-started
</template>

<script>
import BaseLayout from '@/layouts/base'
export default {
  components: {
    BaseLayout
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  .v-main {
    background-color: white;
  }
}
</style>
